package com.sweetlime.bingeamigo.repository

import com.sweetlime.bingeamigo.model.UserActivity
import dev.gitlive.firebase.firestore.FirebaseFirestore

class FirebaseActivityRepository(
    private val firestore: FirebaseFirestore
) : ActivityRepository {

    override suspend fun publishActivity(activity: UserActivity) {
        try {

            // 🌍 Global feed
            firestore.collection("activity")
                .document(activity.id)
                .set(activity)

            // 👤 User feed
            firestore.collection("users")
                .document(activity.userId)
                .collection("activity")
                .document(activity.id)
                .set(activity)

        } catch (e: Exception) {
            e.printStackTrace()
        }
    }
}